import * as layout from './layout'

export class Application {

    constructor() {
        const selectorMapping = {
            '.site-header': layout.Header,
            '.appointment-invitation, .contact-form, .certificates, .featured-articles, .karriarer, .kopprocessen-block, .nyheter-block, .personnel-block, .references, .slider-houses, .slider-striped, .timeline-section': layout.Block,
            '.finder': layout.Finder,
            '.slider-houses': layout.SliderHouses,
            '.ctabs': layout.CTabs,
            '.info-tabs': layout.InfoTabs,
            '.single-property': layout.SingleProperty,
            '.text-block': layout.TextBlock,
            '.image-block': layout.ImageBlock,
            '.objektlista': layout.ObjektList,
            '.projektList': layout.ProjektList,
            '.map-block': layout.MapBlock,
            '.karriarer': layout.Karriarer,
            '.visning-list': layout.VisningList,
            '.references': layout.References,
            '.introBlock': layout.IntroBlock,
            '.singleAuction': layout.Auction,
        }

        this.layouts = {}

        Object.keys(selectorMapping).forEach(selector => {
            const layout = selectorMapping[selector],
                  roots = [].slice.apply(document.querySelectorAll(selector))
            if (roots.length) {
                this.layouts[layout.name] = roots.map(root => new layout(jQuery(root)))
            }
        })
    }
}
